import { ReactNode, useEffect, useState } from 'react';
import * as styles from './UserSection.css';

interface UserSectionProps {
    fullName: string
    email: string
    avatar: ReactNode
    isMobile?: boolean
}

function UserSection({
  fullName, email, avatar, isMobile = false,
}: UserSectionProps) {
  const [device, setDevice] = useState<'desktop' | 'mobile'>('desktop');

  useEffect(() => {
    if (isMobile) {
      return setDevice('mobile');
    }
    return setDevice('desktop');
  }, [isMobile]);

  return (
    <div className={styles.userContainer} data-testid="user-section-container">
      <div className={styles.avatar[device]} data-testid="user-section-avatar">
        {avatar}
      </div>
      <div className={styles.userNameContainer} data-testid="user-section-info">
        <span className={styles.userName[device]} data-testid="user-section-name">{fullName}</span>
        <span className={styles.userEmail[device]} data-testid="user-section-email">{email}</span>
      </div>
    </div>
  );
}

export default UserSection;
